import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet, Navigate, useLocation } from "react-router-dom";
const ProtectedRoute = () => {
  // const token = useSelector((state) => state.auth.token);
  //  return token ? <Outlet /> : <Navigate to="/login" />;

  const token = useSelector((state) => state.auth.token);
  const userData = useSelector((state) => state.auth.userData);
  const location = useLocation();

  // Not logged in → redirect to login
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // Skip all checks for Admin
  if (userData?.role_id === 3) {
    return <Outlet />;
  }

  // Check missing fields
  const isBankDetailsMissing =
    !userData?.account_number ||
    !userData?.bank_ifsc ||
    !userData?.branch_name ||
    !userData?.bank_name ||
    !userData?.first_name ||
    !userData?.middle_name ||
    !userData?.last_name;

  const isProfileDetailsMissing =
    !userData?.profile_pic ||
    !userData?.aadhar_no ||
    !userData?.identity_pic;

  const mustFillBank = userData?.salary > 0 && isBankDetailsMissing;
  // const mustFillProfile = userData?.salary === 0 && isProfileDetailsMissing;

  const mustRedirect = mustFillBank || isProfileDetailsMissing;

  const allowedPath = "/"; // ONLY allowed page when incomplete

  // Missing details AND on wrong page → redirect to /
  if (mustRedirect && location.pathname !== allowedPath) {
    return <Navigate to={allowedPath} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;